function main() {
 // 倒计时
 function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
 }

 let endTimeG;

 function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
   setupNewCountdown();
   leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
   leftM = Math.floor((leftTime / (1000 * 60)) % 60),
   leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
   hour: leftH,
   minute: leftM,
   second: leftS,
  };
 }
 function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
 }

  new Swiper(".sp_pro_swiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: window.screen.width<= 767 ? false : true
      });
  
 let intervalId;

 function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
   let cutDownTimeText = cutDownTime();
   $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
   $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
   $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
 }

 getCutDownTime();

 $(function () {
  $("#root").css("zoom", "normal");
  let scale = document.body.clientWidth / 1080;
  $("#root").css("zoom", scale);

  window.addEventListener(
   "resize",
   (function () {
    var timer;
    return function () {
     if (timer) clearTimeout(timer);
     timer = setTimeout(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);
     }, 100);
    };
   })()
  );
 });

  

 function lazyLoadImages() {
  const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
  const config = {
   rootMargin: "0px 0px 300px 0px",
   threshold: 0,
  };

  const lazyLoadObserver = new IntersectionObserver(function (
   entries,
   observer
  ) {
   entries.forEach(function (entry) {
    if (entry.isIntersecting) {
     // 当图片进入视口时
     const image = entry.target;
     const dataSrc = image.getAttribute("data-src");
     image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
     lazyLoadObserver.unobserve(image); // 停止观察该图片
    }
   });
  },
  config);

  images.forEach(function (image) {
   lazyLoadObserver.observe(image); // 开始观察每个图片
  });
 }

 document.addEventListener("DOMContentLoaded", function () {
  lazyLoadImages();

  // var links = document.querySelectorAll('a[href^="#shopping"]');
  // links.forEach(function(link) {
  //     link.addEventListener("click", function(event) {
  //         event.preventDefault(); // 阻止默认的跳转行为
  //         // var targetElement = document.getElementById('shopping');
  //         // if (targetElement) {
  //         //     targetElement.scrollIntoView({ behavior: 'smooth' });
  //         // } // 方式一
  //         const targetElement = document.getElementById('shopping'); // 获取跳转目标节点
  //         const offsetTop = targetElement.offsetTop ;
  //         window.scroll({
  //             top: offsetTop * ($('div#root').css('zoom')) - 245 * ($('div#root').css('zoom')),
  //             behavior: 'smooth' // 使用 smooth 实现平滑滚动
  //         }); // 方式二
  //     });
  // });
 });

 // IOS字体多了间距的处理 给节点添加 sp_system 类名
 // 判断当前用户是安卓端还是iOS端
 var userAgent = navigator.userAgent || navigator.vendor || window.opera;
 var isAndroid = /android/i.test(userAgent);
 var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
 var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

 if (isAndroid) {
  console.log("Android");
 } else if (isIOS) {
  console.log("iOS");
 } else if (isPC) {
  console.log("PC");
 } else {
  $(".sp_system").css("letter-spacing", "-4px");
 }



  $(".option").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
      });

  function renderLeft(){
    let index = $('.sp_p_1_op2 div.active').index()
    if(index == 0){
      $('.sp_p_img_view1 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer7.png')
    }else {
      $('.sp_p_img_view1 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer8.png')
    }
    let option1 = $('.sp_p_1_op1 div.active').attr('data-val')
    let option2 = $('.sp_p_1_op2 div.active').attr('data-val')
    let price = (window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].price / 100).toFixed(2)
    let compare = (window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].compare_at_price / 100).toFixed(2)
    $('#price1').html(price)
    $('#price2').html(compare)
  }
  
  $('.sp_p_1_op1 div').click(function(){
    renderLeft()
  })
  $('.sp_p_1_op2 div').click(function(){
    renderLeft()
  })

  function renderRight(){
    let option1 = $('.sp_p_1_op3 div.active').attr('data-val')
    let option2 = $('.sp_p_1_op4 div.active').attr('data-val')
    let price = (window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].price / 100).toFixed(2)
    let compare = (window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].compare_at_price / 100).toFixed(2)
    $('#price3').html(price)
    $('#price4').html(compare)
    
    let index1 = $('.sp_p_1_op3 div.active').index()
    let index2 = $('.sp_p_1_op4 div.active').index()
    if(index1 == 0 && index2 == 0 || index1 == 1 && index2 == 0){
      $('.sp_p_img_view2 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer13.png')
    }
    if(index1 == 0 && index2 == 1 || index1 == 1 && index2 == 1){
      $('.sp_p_img_view2 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer14.png')
    }
    if(index1 == 2 && index2 == 0){
      $('.sp_p_img_view2 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer15.png')
    }
    if(index1 == 2 && index2 == 1){
      $('.sp_p_img_view2 img').attr('src', 'https://cdn.shopifycdn.net/s/files/1/0644/4495/6903/files/chamfer16.png')
    }
  }

  $('.sp_p_1_op3 div').click(function(){
    renderRight()
  })
  $('.sp_p_1_op4 div').click(function(){
    renderRight()
  })

  $('.sp_buy_now1').click(function(){
    let option1 = $('.sp_p_1_op1 div.active').attr('data-val')
    let option2 = $('.sp_p_1_op2 div.active').attr('data-val')
    let id = window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].id
    window.location.href = "/cart/" + id + ":1";
  })

  $('.sp_buy_now2').click(function(){
    let option1 = $('.sp_p_1_op3 div.active').attr('data-val')
    let option2 = $('.sp_p_1_op4 div.active').attr('data-val')
    let id = window.product.filter(item=> item.option1 == option1 && item.option2 == option2)[0].id
    window.location.href = "/cart/" + id + ":1";
  })
  
}

main();
